<template>
	<div>
		<div class="table-box" ref="scroll" >
			<!-- 表头 -->
			<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
				<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
					<div class="table-th-cell"
					:style="{'width':rableTitle[0].width + 'px'}" >
						ID
					</div>
					<div class="table-th-cell"
					:style="{'width':rableTitle[1].width + 'px'}" >
						投放信息
					</div>
					<div class="table-th-cell"
					:style="{'width':rableTitle[2].width + 'px'}" >
						书籍选择
					</div>
					<div class="table-th-cell"
					:style="{'width':rableTitle[3].width + 'px'}" >
						投放渠道
					</div>
					<div class="table-th-cell"
					:style="{'width':rableTitle[4].width + 'px'}" >
						投放金额
					</div>
					<div class="table-th-cell"
					:style="{'width':rableTitle[5].width + 'px'}" >
						充值信息
					</div>
					<div class="table-th-cell"
					:style="{'width':rableTitle[6].width + 'px'}" >
						总回报率
					</div>
					
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[7].width + 'px'}" >
					新增粉丝
				</div>
				
				<div class="table-th-cell"
				:style="{'width':rableTitle[8].width + 'px'}" >
					支付粉(当天)
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[9].width + 'px'}" >
					支付粉(总计)
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[10].width + 'px'}" >
					复充统计
				</div>
				
				<!-- 天维度 -->
				<div v-if='day_week_control === "daily"' style="display:flex;align-items: center;">
					<div  v-for="(item,index) in show_day_control" :key="index" >
						<div class="table-th-cell" 
						:style="{'width':day_week_width + 'px'}" >
							D{{index+1}}
						</div>
					</div>
				</div>
				
				<!-- 周维度 -->
				<div v-else style="display:flex;align-items: center;">
					<div  v-for="(item,index) in 8" :key="index" >
						<div class="table-th-cell" 
						:style="{'width':day_week_width + 'px'}" >
							W{{index+1}}
						</div>
					</div>
				</div>
				
				<!-- 占位，隔出一个空白区域 -->
				<div id="" style="width:30px;height: 46px;background-color: #fbfbfb;border-bottom: 1px solid #e8e8e8;">  </div>
			</div>
			
			<!-- 总计 -->
			<div  v-if="Object.keys(tableTotalData).length > 0">
				<div class="table-td" :style="{'width': table_scroll_width + 'px'}">
					<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
						<!-- <div  v-for="(item,index) in tableTotalData" :key="index + 100" style="display: flex;align-items: center;"> -->
							<div class="table-td-cell"
							:style="{'width':rableTitle[0].width + 'px'}">
								所有页总计
							</div>
							<!-- 投放信息 -->
							<div class="table-td-cell"
							:style="{'width':rableTitle[1].width + 'px'}">
								
							</div>
							<!-- 书籍选择 -->
							<div class="table-td-cell"
							:style="{'width':rableTitle[2].width + 'px'}">
								
							</div>
							<!-- 投放渠道 -->
							<div class="table-td-cell"
							:style="{'width':rableTitle[3].width + 'px'}">
								
							</div>
							<!-- 投放金额 -->
							<div class="table-td-cell"
							:style="{'width':rableTitle[4].width + 'px'}"  style="word-wrap: break-word;">
								{{tableTotalData.put_money}}
							</div>
							<!-- 充值信息 -->
							<div class="table-td-cell"
							:style="{'width':rableTitle[5].width + 'px'}" style="font-size:12px;">
								
								<div style="word-wrap: break-word;">消耗：{{tableTotalData.used_money | tableToFixed}}</div>
								<div style="color: #62a8ea;margin: 5px 0;word-wrap: break-word;">充值：{{tableTotalData.charge_money | tableToFixed}}</div>
								<div style="word-wrap: break-word;">分成：{{tableTotalData.left_money | tableToFixed}}</div>
								<div v-if="tableTotalData.earn_money >= 0" style="color: #20c997;margin-top: 5px;word-wrap: break-word;">利润：{{tableTotalData.earn_money}}</div>
								<div v-else style="color: #ea5455;margin-top: 5px;word-wrap: break-word;">利润：{{tableTotalData.earn_money}}</div>
							</div>
							<!-- 总回报率 -->
							<div class="table-td-cell"
							:style="{'width':rableTitle[6].width + 'px'}">
								充值：{{tableTotalData.per}}%
							</div>
							
							
						<!-- </div> -->
					</div>
					
					<!-- 新增粉丝 -->
					<div class="table-td-cell"
					:style="{'width':rableTitle[7].width + 'px'}">
						{{tableTotalData.sub_num}}
					</div>
					
					
					
					<!-- 支付粉(当天) -->
					<div class="table-td-cell"
					:style="{'width':rableTitle[8].width + 'px'}" style="font-size: 12px;">
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<div >粉丝成本：</div>
							<div>￥{{tableTotalData.today_fans_cost}}</div>
						</div>
						
						<div style="display: flex;align-items: center;justify-content: space-between;margin: 5px 0;color: #62a8ea;">
							<div >支付粉成本：</div>
							<div>
								<div>{{tableTotalData.today_pay_user_num}}人</div>
								<div>￥{{tableTotalData.today_vip_cost}}</div>
							</div>
						</div>
						
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<div >支付率：</div>
							<div>{{tableTotalData.today_pay_per}}%</div>
						</div>
					</div>
					
					<!-- 支付粉(总计) -->
					<div class="table-td-cell"
					:style="{'width':rableTitle[9].width + 'px'}" style="font-size: 12px;">
						<div style="display: flex;align-items: center;justify-content: space-between;color: #62a8ea;">
							<div style="flex-shrink: 0;width:80px;text-align:right;">支付粉成本：</div>
							<div>
								<div>{{tableTotalData.pay_user_num}}人</div>
								<div>￥{{tableTotalData.vip_cost}}</div>
							</div>
						</div>
						
						<div style="display: flex;align-items: center;justify-content: space-between;margin: 5px 0;">
							<div style="flex-shrink: 0;width:80px;text-align:right;">支付率：</div>
							<div>{{tableTotalData.pay_per}}%</div>
						</div>
						
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<div style="flex-shrink: 0;width:80px;text-align:right;">产值：</div>
							<div>￥{{tableTotalData.chanzhi}}</div>
						</div>
					</div>
					
					<!-- 复充统计 -->
					<div class="table-td-cell"
					:style="{'width':rableTitle[10].width + 'px'}" style="font-size: 12px;display: flex;flex-wrap: wrap;">
						<!-- 这里循环的是一个对象，value是值，key是键名 -->
						<div v-for="(value,key) in tableTotalData.pay_count_info" style="margin-right: 7px;margin-bottom: 5px;">{{key}}次:{{value}}人</div>

					</div>
				
					<!-- 天维度 -->
					<div v-if='day_week_control === "daily"' style="display:flex;align-items: center;">
						<div  v-for="(item,index) in tableTotalData.table_day" :key="index" >
							<div v-if="item.show_type_control" class="table-td-cell" 
							:style="{'width':day_week_width + 'px'}" style="font-size: 12px;">
								<div style="word-wrap: break-word;color: #62a8ea;">分成：{{item.show_value.money | tableToFixed}}</div>
								<div style="word-wrap: break-word;color: #dda451;">新增：{{item.show_value.incr | tableToFixed}}%</div>
								<div style="word-wrap: break-word;color: #ea5455;">总回：{{item.show_value.total_return | tableToFixed}}%</div>
							</div>
							<div v-else class="table-td-cell"
							:style="{'width':day_week_width + 'px'}" style="font-size: 12px;">
								<div style="word-wrap: break-word;color: #62a8ea;">充值：0</div>
								
							</div>
						</div>
					</div>
					
					<!-- 周维度 -->
					<div v-else style="display:flex;align-items: center;">
						<div  v-for="(item,index) in tableTotalData.table_day" :key="index" >
							<div v-if="item.show_type_control" class="table-td-cell" 
							:style="{'width':day_week_width + 'px'}" style="font-size: 12px;">
								<div style="word-wrap: break-word;color: #62a8ea;">分成：{{item.show_value.money | tableToFixed}}</div>
								<div style="word-wrap: break-word;color: #dda451;">新增：{{item.show_value.incr | tableToFixed}}%</div>
								<div style="word-wrap: break-word;color: #ea5455;">总回：{{item.show_value.total_return | tableToFixed}}%</div>
							</div>
							<div v-else class="table-td-cell"
							:style="{'width':day_week_width + 'px'}" style="font-size: 12px;">
								<div style="word-wrap: break-word;color: #62a8ea;">充值：0</div>
								
							</div>
						</div>
					</div>
				</div>
				
			</div>
			
			
			<!-- 表格内容 -->
			<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
				<!-- 固定列部分 -->
				<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
					<div class="table-td-cell"
					:style="{'width':rableTitle[0].width + 'px'}">
						{{item.id}}
					</div>
					<!-- 投放信息 -->
					<div class="table-td-cell"
					:style="{'width':rableTitle[1].width + 'px'}">
						<div>{{item.date_key}}</div>
						<!-- 公众号 -->
						<div style="margin-top: 5px;color: #ea5455;word-wrap: break-word;">{{item.gzh_name}}</div>
						<!-- 书城渠道 -->
						<div style="margin-top: 5px;color: #ff8acc;word-wrap: break-word;">{{item.channel_name}}</div>
						<!-- 投手 -->
						<div style="margin-top: 5px;color: #62a8ea;word-wrap: break-word;">{{item.op_name}}</div>
					</div>
					<!-- 书籍选择 -->
					<div class="table-td-cell"
					:style="{'width':rableTitle[2].width + 'px'}">
						<!-- 投放小说 -->
						<div style="color: #3085d6;">
							{{item.put_book}}
						</div>
						<div class="edit_" @click="editClick('书籍选择', index, item.put_book)">编辑</div>
						
						<div v-if="item.book_return_require > 0" style="color: #aaa;margin-top: 5px;">首日Roi：{{item.book_return_require}}%</div>
						<div v-else style="color: #aaa;margin-top: 5px;">首日Roi：未设置</div>
						
						<div style="margin-top: 5px;">作品分类：{{item.put_book_category || '无'}}</div>
					</div>
					<!-- 投放渠道 -->
					<div class="table-td-cell"
					:style="{'width':rableTitle[3].width + 'px'}">
						<div style="color: #3085d6;">{{item.media_name}}</div>
						<div @click="editClick('投放渠道', index, item.media_name)" class="edit_">编辑</div>
						
					</div>
					<!-- 投放金额 -->
					<div class="table-td-cell" 
					:style="{'width':rableTitle[4].width + 'px'}">
						<div style="color: #3085d6;word-wrap: break-word;">￥{{item.put_money}}</div>
						<div class="edit_" @click="editClick('投放金额', index, item.put_money)">编辑</div>
						
					</div>
					<!-- 充值信息 -->
					<div class="table-td-cell"
					:style="{'width':rableTitle[5].width + 'px'}" style="font-size: 12px;">
						
						<div style="word-wrap: break-word;">消耗：{{item.used_money | tableToFixed}}</div>
						<div style="color: #62a8ea;margin: 5px 0;word-wrap: break-word;">充值：{{item.charge_money | tableToFixed}}</div>
						<div style="word-wrap: break-word;">分成：{{item.left_money | tableToFixed}}</div>
						<div v-if="item.earn_money >= 0" style="color: #20c997;margin-top: 5px;word-wrap: break-word;">利润：{{item.earn_money}}</div>
						<div v-else style="color: #ea5455;margin-top: 5px;word-wrap: break-word;">利润：{{item.earn_money}}</div>
					</div>
					<!-- 总回报率 -->
					<div class="table-td-cell"
					:style="{'width':rableTitle[6].width + 'px'}">
						<!-- 距开始投放的第几天 -->
						<div>{{item.pass_days}}天</div>
						<div style="font-size: 12px;margin: 5px 0;">充值：{{item.per}}%</div>
						<!-- 第几周回本 -->
						<div>{{item.return_all_str}}</div>
					</div>
					
				</div>
				
				<!-- 非固定列部分 -->
				<!-- 新增粉丝 -->
				<div class="table-td-cell"
				:style="{'width':rableTitle[7].width + 'px'}" style="color: #3085d6;">
					{{item.sub_num}}
					<div class="edit_" @click="editClick('新增粉丝', index, item.sub_num)">编辑</div>
				</div>
				
				
				<!-- 支付粉(当天) -->
				<div class="table-td-cell"
				:style="{'width':rableTitle[8].width + 'px'}" style="font-size: 12px;">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<div>粉丝成本：</div>
						<div>￥{{item.today_fans_cost}}</div>
					</div>
					
					<div style="display: flex;align-items: center;justify-content: space-between;margin: 5px 0;color: #62a8ea;">
						<div>支付粉成本：</div>
						<div>
							<div>{{item.today_pay_user_num}}人</div>
							<div>￥{{item.today_vip_cost}}</div>
						</div>
					</div>
					
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<div>支付率：</div>
						<div>{{item.today_pay_per}}%</div>
					</div>
					
					<div v-if="item.today_arpu > 0" style="display: flex;align-items: center;justify-content: space-between;margin-top: 5px;">
						<div>ARPU：</div>
						<div>{{item.today_arpu}}元</div>
					</div>
				</div>
				
				<!-- 支付粉(总计) -->
				<div class="table-td-cell"
				:style="{'width':rableTitle[9].width + 'px'}" style="font-size: 12px;">
					<div style="display: flex;align-items: center;justify-content: space-between;color: #62a8ea;">
						<div style="flex-shrink: 0;width:80px;text-align:right;">支付粉成本：</div>
						<div>
							<div>{{item.pay_user_num}}人</div>
							<div>￥{{item.vip_cost}}</div>
						</div>
					</div>
					
					<div style="display: flex;align-items: center;justify-content: space-between;margin: 5px 0;">
						<div style="flex-shrink: 0;width:80px;text-align:right;">支付率：</div>
						<div>{{item.pay_per}}%</div>
					</div>
					
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<div style="flex-shrink: 0;width:80px;text-align:right;">产值：</div>
						<div>￥{{item.chanzhi}}</div>
					</div>
				</div>
				
				<!-- 复充统计 -->
				<div class="table-td-cell"
				:style="{'width':rableTitle[10].width + 'px'}" style="font-size: 12px;display: flex;flex-wrap: wrap;">
					<!-- 这里循环的是一个对象，value是值，key是键名 -->
					<div v-for="(value,key) in item.pay_count_info" style="margin-right: 7px;margin-bottom: 5px;">{{key}}次:{{value}}人</div>
				</div>
				
				<!-- 天维度 -->
				<div v-if='day_week_control === "daily"' style="display:flex;align-items: center;">
					<div  v-for="(item_z,index) in item.table_day" :key="index" >
						<div v-if="item_z.show_type_control" class="table-td-cell" 
						:style="{'width':day_week_width + 'px'}" style="font-size: 12px;">
							<div style="word-wrap: break-word;color: #62a8ea;">分成：{{item_z.show_value.money}}</div>
							<div style="word-wrap: break-word;color: #dda451;">新增：{{item_z.show_value.incr}}%</div>
							<div style="word-wrap: break-word;color: #ea5455;">总回：{{item_z.show_value.total_return}}%</div>
							<div class="db-true" v-if="item_z.db === '1'">达标</div>
							<div class="db-false" v-else-if="item_z.db === '2'">未达标</div>
						</div>
						<div v-else class="table-td-cell"
						:style="{'width':day_week_width + 'px'}" style="font-size: 12px;">
							<div style="word-wrap: break-word;color: #62a8ea;">充值：0</div>
							<div class="db-true" v-if="item_z.db === '1'">达标</div>
							<div class="db-false" v-else-if="item_z.db === '2'">未达标</div>
						</div>
						
					</div>
				</div>
				
				<!-- 周维度 -->
				<div v-else style="display:flex;align-items: center;">
					<div  v-for="(item_z,index) in item.table_day" :key="index" >
						<div v-if="item_z.show_type_control" class="table-td-cell" 
						:style="{'width':day_week_width + 'px'}" style="font-size: 12px;">
							<div style="word-wrap: break-word;color: #62a8ea;">分成：{{item_z.show_value.money}}</div>
							<div style="word-wrap: break-word;color: #dda451;">新增：{{item_z.show_value.incr}}%</div>
							<div style="word-wrap: break-word;color: #ea5455;">总回：{{item_z.show_value.total_return}}%</div>
						</div>
						<div v-else class="table-td-cell"
						:style="{'width':day_week_width + 'px'}" style="font-size: 12px;">
							<div style="word-wrap: break-word;color: #62a8ea;">充值：0</div>
						</div>
						
					</div>
				</div>
				
			</div>
			
			
			<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px auto 50px;">
				<a-icon style="font-size: 70px;color: #999;" type="file-search" />
				
				<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
			</div>
			
			
			<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
			<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
			
			
		</div>
		
		
	</div>
</template>

<script>
import { effectUpdate } from '@/request/api'
export default {
	name: 'TableEffect',
	props: ['rableTitle','tableShowData','tableTotalData','table_scroll_width','date_type_control','show_day_control','day_week_control',"day_week_width"],
	data(){
		return {
			
			select_sort_index: "", // 筛选的
			media_name_focus: false, // 焦点
			
			
			edit_modal_title: "", // 编辑弹窗的标题
			// 编辑弹窗的内容
			m_put_money: "", // 投放金额
		}
	},
	methods: {
		// 编辑按钮
		editClick(title,index,value){
			// console.log(11111111111)
			// this.edit_modal_title = "编辑" + title
			// this.visible = true;
			
			this.$emit('edit-table-cell', title, index, value)
		},
		
	},
	filters: {
		tableToFixed(value){
			// console.log("过滤器",value)
			let ttt 
			if(Number(value)){
				
				ttt = Number(value).toFixed(2) // 不转化成数字类型的数据的话，遇到字符串的值就会报错
			}
			else {
				ttt = 0
			}
			return ttt
		}
	}
}
</script>

<style scoped>
.table-box {
	position: relative;
	width: 100%;
	overflow-x: visible;
}

/* .table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
} */
.table-td-cell {
	font-size: 12px;
}

.db-true,
.db-false {
	width: 50px;
	margin-top: 5px;
	text-align: center;
	border-radius: 3px;
	color: #fff;
}
.db-true {
	background-color: #20c997;
}
.db-false {
	background-color: #ea5455;
}

.edit_ {
	display: none;
	height: 20px;
	color: #62a8ea;
	cursor: pointer;
}
.table-td-cell:hover .edit_ {
	display: block;
}
</style>